import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatTooltip } from '@angular/material/tooltip'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderTableComponent,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { ItemWorkSegmentComponent } from '../item-work-segment/item-work-segment.component'
import { ValidationState, WorkItem, WorkItemSegment } from '../work-item'

@Component({
  selector: 'app-item-work-segments',
  templateUrl: './item-work-segments.component.html',
  styleUrls: ['./item-work-segments.component.scss'],
  imports: [
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIcon,
    MatTooltip,
    ItemWorkSegmentComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ItemWorkSegmentsComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  public readonly item$ = new BehaviorSubject<WorkItem>(null)
  public readonly segment$ = new BehaviorSubject<WorkItemSegment>(null)

  @Output()
  public readonly itemReloadRequested = new EventEmitter<WorkItem>()

  public readonly ValidationState = ValidationState

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set item(item: WorkItem) {
    this.item$.next(item)
  }
}
